export default "__VITE_ASSET__Cf9ket5S__"